import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import classnames from 'classnames'

import styles from './coming-soon.css'

function ComingSoon({ wrapperClassName, startDate }) {
  return (
    <div className={classnames(wrapperClassName, styles.wrapper)}>
      <div className={styles.text}>coming soon</div>
      <div className={styles.date}>{format(startDate, 'MMMM do')}</div>
    </div>
  )
}

ComingSoon.propTypes = {
  wrapperClassName: PropTypes.string.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired
}

export default ComingSoon
